// client/src/features/auth/Login.jsx

import React from 'react';

import {
  Box,
  useTheme,
} from '@mui/material';

import {
  useNavigate,
} from 'react-router-dom';

import {
  motion,
} from 'framer-motion';

import useTitle from '../../hooks/useTitle';

import {
  tokens,
} from '../../theme';

import LoginForm from './LoginForm';


const Login = () => {
  useTitle(
    'Employee Login'
  );

  const theme =
    useTheme();

  const colors =
    tokens(
      theme.palette.mode
    );

  const navigate =
    useNavigate();


  const handleLoginSuccess =
    ({
      isFirstLogin,
    }) => {
      if (
        isFirstLogin
      ) {
        navigate(
          '/reset-password'
        );

        return;
      }

      navigate(
        '/console'
      );
    };


  return (
    <Box
      sx={{
        display:
          'flex',

        width:
          '100%',

        justifyContent:
          'center',

        alignItems:
          'center',

        minHeight:
          '100vh',

        backgroundColor:
          colors.grey[600],

        p:
          2,
      }}
    >
      <motion.div
        initial={{
          opacity:
            0,

          scale:
            0.8,
        }}

        animate={{
          opacity:
            1,

          scale:
            1,
        }}

        exit={{
          opacity:
            0,

          scale:
            0.8,
        }}

        transition={{
          duration:
            0.6,
        }}

        style={{
          width:
            '100%',

          maxWidth:
            '400px',
        }}
      >
        <LoginForm
          showBackHome
          onSuccess={
            handleLoginSuccess
          }
        />
      </motion.div>
    </Box>
  );
};


export default Login;